import { createContext } from 'react';

const AuthContextData = {
    signIn: credentials => { },
    isAuthentication: false,
    user: null,
    tenant: null,
    signInTenant: () => {},
    validateTenantOtp: () => {},
    signOutTenant: () => {},
}

const AuthContext = createContext(AuthContextData)

export default AuthContext;